<div class="row">
  <h2 class="col-12">
    <i class="fas fa-chart-line"></i> Apsis One {{ tool }} Delivery Statistics
  </h2>
</div>

<div class="d-flex flex-column options mt-3">
  <div class="d-flex align-items-center">
    <select class="form-control" [formControl]="accountControl">
      <option value="" selected>All Accounts</option>
      <option *ngFor="let account of filteredAccounts" [value]="account.id">
        {{ account.displayName }}
      </option>
    </select>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
      </div>
      <input
        placeholder="Filter accounts"
        type="text"
        class="form-control form-control-sm"
        [formControl]="filterControl"
      />
    </div>
    <span class="reset" (click)="resetFilters()">Reset filters</span>
  </div>
  <div class="d-flex">
    <select class="form-control" [formControl]="timeSpanControl">
      <option *ngFor="let timeValue of timeValues" [value]="timeValue.value">
        {{ timeValue.name }}
      </option>
    </select>
    <div
      *ngIf="timeSpanControl.value === TimeSpanType.RANGE"
      [formGroup]="rangeForm"
      class="d-flex"
    >
      <div class="input-group">
        <input
          class="form-control {{ rangeForm.invalid ? 'is-invalid' : '' }}"
          formControlName="from"
          placeholder="From (yyyy-mm-dd)"
          ngbDatepicker
          #from="ngbDatepicker"
          (click)="from.toggle()"
        />
      </div>
      <div class="input-group">
        <input
          class="form-control {{ rangeForm.invalid ? 'is-invalid' : '' }}"
          formControlName="to"
          placeholder="To (yyyy-mm-dd)"
          ngbDatepicker
          #to="ngbDatepicker"
          (click)="to.toggle()"
        />
      </div>
    </div>
  </div>
  <span
    *ngIf="timeSpanControl.value === TimeSpanType.RANGE && rangeForm.invalid"
    class="range-warning"
    >{{ getError() }}</span
  >
  <div class="d-flex justify-content-end mt-2 mb-3">
    <button
      class="{{
        timeSpanControl.value === TimeSpanType.RANGE && rangeForm.invalid
          ? 'btn btn-secondary'
          : 'btn btn-success'
      }}"
      [disabled]="
        timeSpanControl.value === TimeSpanType.RANGE && rangeForm.invalid
      "
      (click)="updateStatistics()"
    >
      Fetch Statistics
    </button>
  </div>
</div>

<div class="d-flex justify-content-around align-items-center charts">
  <ng-container *ngIf="!loading">
    <div class="d-flex flex-column">
      <app-doughnut-chart [data]="chartData.sent"></app-doughnut-chart>
      <div class="text bold">
        Delivery rate: {{ statistics.deliveryRate * 100 | number: '1.0-1' }} %
      </div>
      <div class="text bold">
        Bounce rate: {{ statistics.bounceRate * 100 | number: '1.0-1' }} %
      </div>
    </div>
    <div class="d-flex flex-column">
      <app-doughnut-chart [data]="chartData.clicks"></app-doughnut-chart>
      <div class="text bold">
        Click rate: {{ statistics.clickRate * 100 | number: '1.0-1' }} %
      </div>
    </div>
    <div class="d-flex flex-column" *ngIf="tool === Tool.Email">
      <app-doughnut-chart [data]="chartData.opens"></app-doughnut-chart>
      <div class="text bold">
        Open rate: {{ statistics.openRate * 100 | number: '1.0-1' }} %
      </div>
    </div>
  </ng-container>
</div>

<div class="d-flex" *ngIf="tool === Tool.Email">
  <div class="d-flex flex-column align-items-center spam">
    <div><i class="fas fa-exclamation-triangle fa-lg"></i></div>
    <div class="text">Spam Complaints</div>
    <div class="text">{{ statistics.abuse }}</div>
  </div>
  <div class="d-flex flex-column align-items-center unsubscribes">
    <div><i class="fas fa-bell-slash fa-lg"></i></div>
    <div class="text">Unsubscribes</div>
    <div class="text">{{ statistics.uniqueUnsubscribe }}</div>
  </div>
</div>

<app-bar-chart
  [statistics]="statisticsTimeSpan"
  [interval]="interval"
  [tool]="tool"
></app-bar-chart>

<ng-container [ngSwitch]="tool">
  <ng-container *ngSwitchCase="Tool.Email">
    <app-statistics-table
      [statistics]="domains$ | async"
      (downloadClick)="downloadCSV($event)"
    ></app-statistics-table>

    <app-statistics-table
      header="Latest sendings"
      orderBy="createdAt"
      [toggles]="sendingsToggles$ | async"
      [type]="StatisticsType.SENDINGS"
      [sticky]="{ title: 'Account ID', prop: 'accountId', filter: true }"
      [statistics]="sendings$ | async"
      [extraHeaders]="[
        {
          title: 'Activity ID',
          prop: 'activityId',
          filter: true,
          size: 'big',
          clickable: true
        },
        { title: 'Date/Time', prop: 'createdAt', timestamp: true },
        { title: 'Type', prop: 'type' }
      ]"
      (rowClick)="openWebVersion($event)"
      (toggleClick1)="includeTrigger1$.next($event)"
      (toggleClick2)="includeTrigger2$.next($event)"
      (downloadClick)="downloadCSV($event)"
    ></app-statistics-table>
  </ng-container>

  <app-statistics-table
    *ngSwitchCase="Tool.Sms"
    header="Top country codes"
    [sticky]="{ title: 'Country Code', prop: 'countryCode', filter: true }"
    [statistics]="countryCodes$ | async"
    [showDownloadButton]="false"
    [headers]="[
      { title: 'Sent', prop: 'sent' },
      { title: 'Delivered', prop: 'normalizedDelivered' },
      { title: 'Delivery rate', prop: 'deliveryRate' },
      { title: 'Bounced', prop: 'uniqueBounce' },
      { title: 'Bounce rate', prop: 'bounceRate' },
      { title: 'Clicks', prop: 'click' },
      { title: 'Unique clicks', prop: 'uniqueClick' },
      { title: 'Click rate', prop: 'clickRate' }
    ]"
  ></app-statistics-table>
</ng-container>

<div *ngIf="loading">
  <app-loading-spinner></app-loading-spinner>
</div>
